"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var inertia_react_1 = require("@inertiajs/inertia-react");
var react_1 = __importDefault(require("react"));
require("./Link.scss");
var GlobalLinkEl = inertia_react_1.InertiaLink;
function setGlobalLinkEl(linkEl) {
    GlobalLinkEl = linkEl;
}
exports.setGlobalLinkEl = setGlobalLinkEl;
function resetGlobalLinkEl() {
    GlobalLinkEl = inertia_react_1.InertiaLink;
}
exports.resetGlobalLinkEl = resetGlobalLinkEl;
var Link = function (props) {
    var _a = props.use, use = _a === void 0 ? GlobalLinkEl : _a, _b = props.children, children = _b === void 0 ? null : _b, _c = props.className, className = _c === void 0 ? null : _c, _d = props.dusk, dusk = _d === void 0 ? undefined : _d, _e = props.label, label = _e === void 0 ? null : _e, _f = props.href, href = _f === void 0 ? null : _f, _g = props.onClick, onClick = _g === void 0 ? null : _g, otherProps = __rest(props, ["use", "children", "className", "dusk", "label", "href", "onClick"]);
    var passThroughProps = __assign({ 'data-dusk': dusk, className: className,
        href: href, onClick: onClick || undefined }, otherProps);
    return react_1.default.createElement(use, passThroughProps, children || label);
};
exports.default = Link;
//# sourceMappingURL=index.js.map